// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `select {
  margin-bottom: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/app/issue-tracker/issue-dialog/issue-dialog.component.less"],"names":[],"mappings":"AAEA;EACI,mBAAA;AADJ","sourcesContent":["@import (reference) url('../../../assets/ngb-modals.less');\n\nselect {\n    margin-bottom: 15px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
